<template>
    <div id="cookie" class="container">
        <SfBreadcrumbs
                :breadcrumbs="breadcrumbs"
                class="breadcrumbs"
        />
        <div v-if="locale!=='en'" class="content">
            <h1> POLITIQUE DE GESTION DES COOKIES</h1>
            <p>Cette politique explique comment nous utilisons les cookies lorsque vous visitez le site web
                shopping.airfrance.com et les sites associés ainsi que notre application (ci-après conjointement
                dénommés « notre site »).</p>
            <p>En cliquant sur le bouton « Accepter » dans la bannière cookies, vous consentez à l’installation des
                types de
                cookies décrits ci-dessous.</p>
            <a id="setCookie" class="sf-button color-secondary" href="#">Je modifie mes choix en matière de cookies
            </a>
            <h2>Que sont les cookies ?</h2>
            <p>Les cookies sont des fichiers de données qui sont téléchargés sur votre appareil par le site Internet ou
                l'application que vous visitez. Les cookies permettent à votre appareil d'être reconnu lors de votre
                prochaine visite.
                En utilisant les cookies et autres technologies similaires, telles que les pixels espions/balises web et
                les scripts (ci-après conjointement dénommés « cookies »), les sites Internet et les applications
                peuvent alors recueillir des informations à propos des visites et des visiteurs.
                Ces informations peuvent inclure votre adresse IP, ainsi que l'appareil, le navigateur et le système
                d'exploitation que vous utilisez et votre comportement de clic, comme les pages spécifiques que vous
                visitez et la façon dont vous naviguez sur le site web ou l'application.
                Les cookies de session restent en place pendant toute la durée de votre session de navigation ou
                d'application, tandis que les cookies persistants restent sur votre appareil pendant une période
                prédéfinie.
                Certains cookies sont placés par nos soins, tandis que d'autres sont placés par des tiers. Les cookies
                tiers peuvent également recueillir des données en dehors de notre site.</p>
            <h2>Quel type de cookies utilisons-nous ?</h2>
            <p>Lorsque vous visitez notre site, nous utilisons toujours des cookies fonctionnels et analytiques aux fins
                décrites ci-dessous. Avec votre consentement, nous utilisons également des cookies à des fins de
                marketing.
                Lorsque nous recueillons des données personnelles vous concernant via des cookies, nous les traitons aux
                fins énoncées dans la politique de confidentialité d'Air France.</p>
            <p>Lire
                <SfLink :link="$localizePath('/politique-de-protection-des-donnees-personnelles')">la politique de
                    confidentialité d’Air France
                </SfLink>
            </p>

            <h3>Les cookies fonctionnels</h3>
            <p>Les cookies fonctionnels sont nécessaires pour afficher et utiliser sans problème notre site.
                Nous utilisons également ces cookies pour enregistrer vos préférences en matière de langue et les
                paramètres (de cookies). Les informations recueillies par l'intermédiaire de ces cookies ne sont pas
                utilisées à des fins commerciales.
                Les cookies fonctionnels sont essentiels à notre site et peuvent être placés sur votre appareil sans
                votre consentement. Si vous bloquez ce type de cookies, il se peut que notre site ne fonctionne pas
                correctement et que vous ne puissiez pas en utiliser toutes les fonctionnalités.</p>


            <h3>Les cookies analytiques</h3>
            <p>Les cookies analytiques collectent des informations sur la façon dont les visiteurs utilisent notre site,
                notamment des informations à propos des pages les plus consultées, du temps passé par les utilisateurs
                sur ces pages, ou à propos d'éventuelles erreurs qu'ils peuvent rencontrer.
                Nous utilisons ces cookies pour réaliser des enquêtes auprès des utilisateurs et pour rassembler les
                commentaires des visiteurs, à propos de notre site en général ou à propos d'éléments spécifiques de
                notre site.
                Ces informations nous permettent de mieux comprendre quelles parties de notre site intéressent nos
                visiteurs et identifier comment améliorer la qualité de notre site.
                Nous utilisons également les cookies fonctionnels pour tester les nouvelles caractéristiques et les
                différentes variantes et conceptions de notre site.
                Les cookies analytiques que nous utilisons sont mis en œuvre de manière à respecter la vie privée,
                minimisant la quantité de données que nous collectons sur les visiteurs individuels. Ces cookies peuvent
                être installés sur votre appareil sans votre consentement.</p>

            <h2>Les cookies marketing</h2>
            <p>Nous utilisons ces cookies pour :</p>
            <ul>
                <li>analyser l'efficacité de nos campagnes marketing (« Performance »),</li>
                <li>nous aider à adapter notre contenu et nos publicités par rapport à vos intérêts (« Publicité et
                    médias sociaux »).
                </li>
            </ul>
            <h4>Performance</h4>

            <p>Lorsque vous choisissez ce paramètre, nous utilisons des cookies pour analyser l'efficacité de nos
                actions marketing et pour comparer les performances de nos campagnes marketing. Le choix de ce paramètre
                ne signifie pas nécessairement que nous installerons des cookies supplémentaires. Cependant, nous
                enrichirons les données que nous avons collectées avec d'autres données grâce à des cookies analytiques.
                Les données enrichies ne seront jamais utilisées pour le ciblage individuel.</p>
            <h4>Publicité et médias sociaux</h4>
            <p>Nous utilisons des cookies pour recueillir des informations sur vos visites et vos clics sur notre site
                et sur des applications et des sites Internet tiers, afin d'adapter la pertinence de notre contenu et de
                nos publicités à vos intérêts. À cette fin, nous pouvons également partager ces informations avec des
                tiers, par exemple pour participer à des programmes d'audience personnalisés de plateformes de médias
                sociaux.</p>
            <p>Ces cookies sont également placés par des réseaux publicitaires tiers. Ces réseaux sont des entreprises
                qui agissent en tant qu'intermédiaires entre nous et les publicitaires. Ils recueillent des informations
                sur votre utilisation de notre site et d'applications et sites Internet tiers.</p>
            <p>Ce type de cookies est utilisé pour :</p>
            <ul>
                <li>mesurer l'efficacité des campagnes publicitaires en comptant le nombre de clics et de conversions,
                </li>
                <li>vous proposer des publicités ou des offres pertinentes et personnalisées par email, sur les réseaux
                    sociaux et via des bannières publicitaires sur des sites Internet tiers, en fonction de vos visites
                    et de votre comportement en matière de clics sur notre site et sur des applications et sites
                    Internet tiers,
                </li>
                <li>limiter le nombre de fois que vous voyez une publicité.</li>
            </ul>
            <p>Nous utilisons des cookies de plateformes de réseaux sociaux telles que Facebook et Twitter pour voir si
                vous êtes connecté(e) sur leur plateforme. Ces cookies vous permettent d'aimer du contenu ou de le
                partager avec vos amis via ces plateformes. Ces plateformes peuvent utiliser ces cookies à leurs propres
                fins, y compris la publicité.</p>
            <p><a class="sf-link" href="/assets/pdf/list-cookies-FR.pdf" target="_blank">Découvrir la liste complète des
                cookies et des tiers</a></p>
            <h2>Régler les paramètres cookies et/ou supprimer les cookies</h2>
            <p>Vous pouvez modifier vos préférences en matière de cookies pour les cookies marketing ou retirer votre
                consentement à tout moment en ouvrant les « Paramètres des cookies » en bas de toutes les pages de notre
                site web ou via le menu des paramètres de l'application.</p>
            <p>Si vous nous avez précédemment donné votre consentement, mais souhaitez supprimer les cookies que nous
                avons placés, vous pouvez le faire en les supprimant à partir de votre navigateur ou des paramètres de
                votre appareil.</p>
            <p>Vous pouvez également régler les paramètres de votre navigateur ou de votre appareil pour empêcher les
                sites Internet de placer des cookies ou empêcher les cookies provenant de tiers.</p>
            <p>Si vous faites cela, il se peut que certaines fonctionnalités de notre site soient indisponibles ou
                qu'elles ne fonctionnent pas correctement.</p>
            <p>Découvrez comment régler vos paramètres en fonction de votre navigateur :</p>
            <ul>
                <li><a class="sf-link" href="https://support.apple.com/fr-fr/guide/safari/sfri11471/mac"
                       target="_blank">Safari</a></li>
                <li><a class="sf-link" href="https://support.google.com/chrome/answer/95647?hl=fr"
                       target="_blank">Chrome</a></li>
                <li><a class="sf-link" href="https://support.mozilla.org/fr/kb/cookies-informations-sites-enregistrent"
                       target="_blank">Firefox</a></li>
                <li><a class="sf-link"
                       href="https://support.microsoft.com/fr-fr/topic/supprimer-et-g%C3%A9rer-les-cookies-168dab11-0753-043d-7c16-ede5947fc64d#ie=ie-11"
                       target="_blank">Internet explorer / Edge</a></li>
            </ul>
            <p>Pour trouver des informations relatives à d'autres navigateurs, visitez le site Internet du développeur
                du navigateur.</p>
            <h2>À propos de cette politique</h2>
            <p>En cas de changement de la présente politique ou des cookies placés, nous modifierons le texte de la
                politique et la liste des cookies placés en conséquence. Nous vous informerons de tout changement
                majeur.
            </p>
            <p>Cette politique de cookies a été mise à jour le 24 Avril 2023.</p>
        </div>
        <div v-else class="content">
            <h1>MANAGING COOKIES ON SHOPPING.AIRFRANCE.COM</h1>
            <p>This policy explains how we make use of cookies when you visit the airfrance.com website, related sites,
                and our app (hereinafter together referred to as ‘our site’).</p>
            <p>By clicking on the “Accept” button in the cookies banner, you consent to installing the types of cookies
                described in this cookies policy on your browser.</p>
            <a id="setCookie" class="sf-button color-secondary" href="#">MODIFY MY COOKIES SETTINGS
            </a>
            <h2>What are cookies?</h2>
            <p>Cookies are small data files that are downloaded to your device by the website or app you are visiting or
                using.</p>
            <p>On your next visit, cookies ensure that your device is recognized.</p>
            <p>By using cookies and similar technologies, such as pixel tags/beacons and scripts (hereafter together
                referred to as 'cookies'), websites and apps can save information about visits and visitors.</p>
            <p>This information may include your IP address, as well as the device, browser, and operating system you
                are using, and your click behavior, such as the specific pages you visit and how you navigate the
                website or app.</p>
            <p>Session cookies stay in place for the duration of your browser or app session, while persistent cookies
                remain on your device for a pre-defined period.</p>
            <p>We place some of the cookies ourselves, while other cookies are placed by third parties. Third-party
                cookies may collect data outside our site as well.</p>


            <h2>What types of cookies do we use?</h2>
            <p>When you visit our site, we always use functional and analytical cookies for the purposes as set out
                hereunder. With your consent, we also use cookies for marketing purposes.</p>
            <p>When we collect personal data about you via cookies, we process these for the purposes stated in the Air
                France privacy policy.</p>
            <SfLink :link="$localizePath('/politique-de-protection-des-donnees-personnelles')">Read the Air France's
                privacy
                policy
            </SfLink>
            .


            <h3>Functional cookies</h3>
            <p>Functional cookies are necessary so you can view and use our site properly. We also use these cookies to
                remember your language preferences and (cookie) settings.</p>
            <p>The information collected by these cookies is not used for marketing purposes. Functional cookies are
                essential to our site, and they may be placed on your device without your consent.</p>
            <p> If you block this type of cookie, our site may not work properly, and you may not be able to use all the
                features.
            </p>
            <h3>Analytical cookies</h3>
            <p>Analytical cookies collect information on how visitors use our site, including information about the most
                visited pages, for how long they are visited, and if users experience any errors.</p>
            <p>In addition, we use these cookies to conduct user surveys and to gather visitor feedback about our site
                in general or about specific elements of our site.</p>
            <p>We use this information to help us understand which parts of our site interest our visitors and to help
                improve the quality of our site.</p>
            <p>We also use cookies for A/B testing, which enables us to test new features and different variants and
                designs of our site.</p>
            <p>The analytical cookies that we use are implemented in a privacy-friendly way, minimizing the amount of
                data that we collect about individual visitors. Therefore, these cookies may be placed on your device
                without your consent.</p>

            <h3>Marketing cookies</h3>
            <p>We use cookies to:</p>
            <ul>
                <li>analyze the effectiveness of our marketing campaigns (“Performance”),</li>
                <li>help us make our content and advertisements more relevant to your interests (“Advertisement and
                    social media”).
                </li>
            </ul>
            <h4>Performance</h4>
            <p>When you choose this setting, we use cookies to analyze the effectiveness of our marketing actions and to
                compare performance across our marketing campaigns. Choosing this setting does not necessarily mean that
                we will set additional cookies.
                We will however enrich the data that we have collected through analytical cookies with other data. The
                enriched data will never be used for individual targeting.</p>
            <h4>Advertisements and social media</h4>
            <p>We use cookies to collect information on your visits to and clicks on our site and third-party websites
                and apps to make our content and advertisements relevant to your interests.
                To this end, we may also share this information with third parties, for example, to participate in
                custom audience programs on social media platforms.</p>
            <p>These cookies are also placed by third-party advertising networks. These networks are companies that act
                as intermediaries between us and advertisers. They collect information about your use of our site and
                third-party websites and apps.</p>
            <p>These cookies are used to:</p>
            <ul>
                <li>measure the effectiveness of our advertising campaigns by tracking the number of clicks and
                    conversions
                </li>
                <li>show you relevant, personalized advertisements or offers via e-mail, social media, and banner ads on
                    third-party websites, based on your visits to and click behavior on our site and third-party
                    websites and apps
                </li>
                <li>limit the number of times you see an advertisement</li>
            </ul>

            <p>We use cookies on social media platforms such as Facebook and Twitter to see if you are logged in on
                their platform. These cookies allow you to like content or share it with your friends through these
                platforms. These platforms may use these cookies for their purposes, including advertising.</p>
            <p><a class="sf-link" href="/assets/pdf/list-cookies-EN.pdf" target="_blank">Check the full list of cookies
                and third parties</a></p>

            <h2>Adjusting cookie settings and deleting cookies</h2>
            <p>You can change your cookie preferences for marketing cookies or withdraw your consent at any time by
                opening the ‘Cookie settings’ at the bottom of all pages on our website or via the settings menu in the
                app.</p>
            <p>If you have previously given us your consent but would like to remove the cookies that we have placed,
                you can do this by deleting these cookies via your browser or the settings on your device. You may also
                adjust your browser or device settings to prevent websites from setting cookies or third-party cookies
                altogether.</p>
            <p>If you do this some functions of our site may not be available or not function properly. Find out how to
                adjust the settings for different browsers:</p>
            <ul>
                <li><a class="sf-link" href="https://support.apple.com/fr-fr/guide/safari/sfri11471/mac"
                       target="_blank">Safari</a></li>
                <li><a class="sf-link" href="https://support.google.com/chrome/answer/95647?hl=fr"
                       target="_blank">Chrome</a></li>
                <li><a class="sf-link" href="https://support.mozilla.org/fr/kb/cookies-informations-sites-enregistrent"
                       target="_blank">Firefox</a></li>
                <li><a class="sf-link"
                       href="https://support.microsoft.com/fr-fr/topic/supprimer-et-g%C3%A9rer-les-cookies-168dab11-0753-043d-7c16-ede5947fc64d#ie=ie-11"
                       target="_blank">Internet explorer / Edge</a></li>
            </ul>
            <p>To find information relating to other browsers, visit the browser developer's website.</p>

            <h2>About this policy</h2>
            <p>If this cookie policy or the cookies placed change, we will adjust the policy and the list of cookies
                placed. We will inform you about substantial changes.</p>
            <p>This cookie policy was updated on April 24, 2023.</p>
        </div>
    </div>
</template>

<script>
import {SfBreadcrumbs, SfLink} from "@storefront-ui/vue"
import Api from '@/api/Api';


export default {
    name: "Cookies",
    components: {
        SfLink,

        SfBreadcrumbs
    },
    data() {
        return {
            breadcrumbs: null,
            loading: false,
            error: false,
            content: null,
        }
    },
    computed: {
        locale: {
            get() {
                return this.$root.$i18n.locale
            }
        },
    },
    created() {
        this.setBreadcrumbs();

    },
    methods: {
        setBreadcrumbs() {

            this.breadcrumbs = [{
                text: this.$i18n.t('Home'),
                link: '/'
            }, {
                text: this.$i18n.t('cookie.pageTitle'),
            }];

        },

    },
}
</script>

<style lang="scss" scoped>
#setCookie {
  text-align: center;
  display: inline-block;
  margin: var(--spacer-base) auto var(--spacer-xl);
}

::v-deep {
  .sf-button {
    justify-content: space-between !important;
  }
}

.error-msg {
  text-align: center;
}
</style>